export class LoadUserResourceAction {
  static readonly type = '[App] LoadUserResourceAction';
}

export class DisconnectUserAction {
  static readonly type = '[App] DisconnectUserAction';

  /**
   * @param theAccountIsAlreadyGone true when the account this session belongs
   * to no longer exists on the server, which happens on exactly one path: the
   * member has just deleted it.
   *
   * WHY IT MATTERS. Disconnecting normally tells the server to forget the push
   * token and the location access, two authenticated calls. After a deletion
   * those calls carry the credentials of an account the API has just removed,
   * so they cannot succeed: they answer 401, the interceptor tries to renew the
   * token, Firebase answers «there is no user record corresponding to this
   * identifier» because the API deleted the Firebase account too, and the whole
   * self-inflicted sequence is reported as a production error.
   *
   * CAPACITOR-D and CAPACITOR-R are that sequence, and nothing else. Their
   * breadcrumbs read: DELETE /profile 200, remove-push-token 401,
   * «no user record», remove-location-access 401.
   *
   * There is nothing to clean up anyway. The deletion handler anonymises the
   * profile, soft-deletes the user and deletes the Firebase account, so the
   * server has already forgotten everything these two calls would ask it to
   * forget.
   */
  constructor(public readonly theAccountIsAlreadyGone = false) {}
}

export class ShowToastMessageAction {
  static readonly type = '[App] ShowToastMessageAction';

  /**
   * `position` defaults to the top, where most confirmations appear. A screen
   * whose own toasts sit at the bottom passes 'bottom', so a confirmation does
   * not land over its header while its errors appear at the bottom.
   */
  constructor(
    public message: string,
    public icon?: string,
    public duration?: number,
    public position: 'top' | 'bottom' = 'top',
  ) {}
}
